import React from 'react';
import { makeStyles } from '@material-ui/core';
import { isProduction, isStage, isTest } from 'config';
import { BRAND } from 'theme';

interface EnvMarker {
  label: string;
  color: string;
  text: string;
}

// Маркер среды: тест и стейдж визуально одинаковы, и без него стенды путают. На проде маркера нет.
const getEnvMarker = (): EnvMarker | null => {
  if (isProduction) return null;
  if (isStage) return { label: 'Стейдж', color: '#2A9D8F', text: '#fff' };
  if (isTest) return { label: 'Тест', color: '#FFD666', text: BRAND.ink };
  return { label: 'Локально', color: '#8FA3BF', text: BRAND.ink };
};

const ENV = getEnvMarker();

/** Цвет полоски среды по верхнему краю шапки; undefined на проде. */
export const ENV_COLOR = ENV?.color;

const useStyles = makeStyles((theme) => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.25, 1.25),
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '16px',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    backgroundColor: ENV?.color,
    color: ENV?.text,
  },
}));

const EnvBadge = () => {
  const classes = useStyles();

  if (!ENV) return null;

  return (
    <span className={classes.badge} title={`Среда: ${ENV.label}`}>
      {ENV.label}
    </span>
  );
};

export default EnvBadge;
